import { createRouter, createWebHistory } from 'vue-router'
import IndexPage from '../view/index/index.vue'
import AboutPage from '../view/about/index.vue'
import ContactPage from '../view/contact/index.vue'
import HomePage from '../view/home/index.vue'
import ProductPage from '../view/product/index.vue'
import SolutionPage from '../view/solution/index.vue'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: IndexPage,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: HomePage
      },
      {
        path: '/about',
        name: 'About',
        component: AboutPage
      },
      {
        path: '/contact',
        name: 'Contact',
        component: ContactPage
      },
      {
        path: '/product',
        name: 'Product',
        component: ProductPage
      },
      {
        path: '/solution',
        name: 'Solution',
        component: SolutionPage
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
